"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "PosthogSurveyResponseSchema", {
    enumerable: true,
    get: function() {
        return PosthogSurveyResponseSchema;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const PosthogSurveyQuestionSchema = _zod.z.object({
    question: _zod.z.string(),
    response: _zod.z.unknown()
});
const PosthogSurveyResponseSchema = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    eventUuid: _zod.z.string(),
    surveyId: _zod.z.string().nullable(),
    surveyName: _zod.z.string().nullable(),
    surveyQuestions: _zod.z.array(PosthogSurveyQuestionSchema),
    distinctId: _zod.z.string(),
    personId: _zod.z.string().nullable(),
    personName: _zod.z.string().nullable(),
    personProperties: _zod.z.record(_zod.z.string(), _zod.z.unknown()).nullable(),
    companyId: _zod.z.string().nullable(),
    eventName: _zod.z.string(),
    eventProperties: _zod.z.record(_zod.z.string(), _zod.z.unknown()).nullable(),
    eventTimestamp: _zod.z.string(),
    projectId: _zod.z.number().nullable(),
    projectName: _zod.z.string().nullable(),
    receivedAt: _zod.z.date()
});
